import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Footer from '../../components/Footer/Footer'

import HeaderAds from '../../components/Bar/HeaderAds'
import GalerieSectionA from '../../components/Galeries/GalerieSectionA'
import Header from '../../components/Bar/Header'

const Galeries = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
  
      <Header />
     

      <GalerieSectionA />
     
     
      <Footer />
    </motion.div>
  )
}

export default Galeries
